import { Injectable } from '@angular/core';
import { SocketMiddlewareService } from './socket-middleware.service';
import { MatrixChannelEvents } from 'icreate/common/io-event/websocket-message';

@Injectable({
    providedIn: 'root',
})
export class MatrixChannelSocketService {
    constructor(private socketService: SocketMiddlewareService) {}

    matrixChannelCreated$() {
        return this.socketService.receiveMessageObserver(MatrixChannelEvents.MATRIX_CHANNEL_CREATED);
    }

    matrixChannelUpdated$() {
        return this.socketService.receiveMessageObserver(MatrixChannelEvents.MATRIX_CHANNEL_UPDATED);
    }

    matrixChannelDeleted$() {
        return this.socketService.receiveMessageObserver(MatrixChannelEvents.MATRIX_CHANNEL_DELETED);
    }
}
